import AboutModal from './AboutModal.json';
import Buttons from './Buttons.json';
import CineDialog from './CineDialog.json';
import Common from './Common.json';
import Colormaps from './Colormaps.json';
import DataSourceConfiguration from './DataSourceConfiguration.json';
import DatePicker from './DatePicker.json';
import ErrorBoundary from './ErrorBoundary.json';
import Header from './Header.json';
import HotkeysValidators from './HotkeysValidators.json';
import MeasurementTable from './MeasurementTable.json';
import DataRow from './DataRow.json';
import Messages from './Messages.json';
import Modals from './Modals.json';
import Modes from './Modes.json';
import Onboarding from './Onboarding.json';
import PanelSUV from './PanelSUV.json';
import PatientInfo from './PatientInfo.json';
import ROIThresholdConfiguration from './ROIThresholdConfiguration.json';
import SegmentationPanel from './SegmentationPanel.json';
import SidePanel from './SidePanel.json';
import StudyBrowser from './StudyBrowser.json';
import StudyItem from './StudyItem.json';
import StudyList from './StudyList.json';
import ToolTip from './ToolTip.json';
import TooltipClipboard from './TooltipClipboard.json';
import ThumbnailTracked from './ThumbnailTracked.json';
import TrackedCornerstoneViewport from './TrackedCornerstoneViewport.json';
import UserPreferencesModal from './UserPreferencesModal.json';
import ViewportDownloadForm from './ViewportDownloadForm.json';
import WindowLevelActionMenu from './WindowLevelActionMenu.json';
import CaptureViewportModal from './CaptureViewportModal.json';
import Tools from './Tools.json';
import Hps from './Hps.json';
import ToolbarLayoutSelector from './ToolbarLayoutSelector.json';
import ToolbarModeSelector from './ToolbarModeSelector.json';
import USAnnotationPanel from './USAnnotationPanel.json';

export default {
  'test-LNG': {
    AboutModal,
    Buttons,
    CineDialog,
    Common,
    Colormaps,
    DataSourceConfiguration,
    DatePicker,
    ErrorBoundary,
    Header,
    HotkeysValidators,
    MeasurementTable,
    DataRow,
    Messages,
    Modals,
    Modes,
    Onboarding,
    PanelSUV,
    PatientInfo,
    ROIThresholdConfiguration,
    SegmentationPanel,
    SidePanel,
    StudyBrowser,
    StudyItem,
    StudyList,
    ToolTip,
    TooltipClipboard,
    ThumbnailTracked,
    TrackedCornerstoneViewport,
    UserPreferencesModal,
    ViewportDownloadForm,
    WindowLevelActionMenu,
    CaptureViewportModal,
    Tools,
    Hps,
    ToolbarLayoutSelector,
    ToolbarModeSelector,
    USAnnotationPanel,
  },
};
